import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PhoneNumberDTO } from '@iota/iota-management-portal-v4-client';
import { ContactInformationTypeDescription, ContactInformationTypes } from '../../constants-and-enums/contact-information-type';
import { deepCopy } from '../../constants-and-enums/default-objects';

@Component({
    standalone: false,
    selector: 'app-phone-number',
    templateUrl: './phone-number.component.html',
    styleUrls: ['./phone-number.component.scss']
})
export class PhoneNumberComponent implements OnInit {
    contactInformationTypes = ContactInformationTypes;
    editMode = false;

    @Input() private phoneNumber: PhoneNumberDTO;
    updatedPhoneNumber: PhoneNumberDTO;

    @Output() delete: EventEmitter<PhoneNumberDTO> = new EventEmitter();
    @Output() save: EventEmitter<PhoneNumberDTO> = new EventEmitter();
    @Output() cancelEdit: EventEmitter<PhoneNumberDTO> = new EventEmitter();

    ngOnInit(): void {
        this.updatedPhoneNumber = deepCopy(this.phoneNumber);
        if (!this.updatedPhoneNumber.phoneNumberId && !this.phoneNumber.phoneNumber) {
            this.editMode = true;
        }
    }

    getContactInformationTypeDescription(contactInformationType: string) {
        return ContactInformationTypeDescription.get(contactInformationType);
    }

    cancelEditing(): void {
        this.updatedPhoneNumber = deepCopy(this.phoneNumber);
        this.cancelEdit.emit(this.phoneNumber);
    }

    savePhoneNumber(): void {
        this.save.emit(this.getUpdatedPhoneNumber());
        this.editMode = false;
    }

    getUpdatedPhoneNumber(): PhoneNumberDTO {
        return this.updatedPhoneNumber;
    }
}
